<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>{{ modalTitle }}</h2>
      <div class="close" (click)="bsModalRef.hide()">
        <img src="/assets/img/close-white.svg" alt="" />
      </div>

      <div class="loading" [ngClass]="loading ? 'active' : ''">
        <div></div>
      </div>

      <div class="fields__container">
        <form autocomplete="off" name="userProfileForm" #userProfileForm="ngForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section" *ngIf="userProfile">

              <div class="field-row">
                <label class="field-label">User Name:</label>
                <span class="field-value" [attr.title]="userProfile.userName">{{ userProfile.userName }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Email:</label>
                <span class="field-value" [attr.title]="userProfile.email">{{ userProfile.email }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Organisation Name:</label>
                <span class="field-value" [attr.title]="userProfile.organizationName">{{ userProfile.organizationName }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Organisation Type:</label>
                <span class="field-value" [attr.title]="userProfile.organizationType">{{ userProfile.organizationType }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Role:</label>
                <span class="field-value" [attr.title]="userProfile.role">{{ userProfile.role }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Country:</label>
                <span class="field-value" [attr.title]="userProfile.country">{{ userProfile.country }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Status:</label>
                <span class="field-value">{{ userProfile.userState }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Expiry Date:</label>
                <span class="field-value">{{ formatDate(userProfile.dueDate) }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Approval Date:</label>
                <span class="field-value">{{ formatDate(userProfile.approvalDate) }}</span>
              </div>
              <div class="field-row">
                <label class="field-label">Agreement Type:</label>
                <span class="field-value">{{ userProfile.agreementType }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Payment Status:</label>
                <span class="field-value" [attr.title]="userProfile.paymentStatus">{{ userProfile.paymentStatus }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Reference License:</label>
                <span class="field-value" [attr.title]="userProfile.referenceLicense">{{ userProfile.referenceLicense }}</span>
              </div>
               <div class="field-row">
                <label class="field-label">Admin Manager:</label>
                <span class="field-value" [attr.title]="userProfile.adminManager">{{ userProfile.adminManager }}</span>
              </div>

              <div class="field-row">
                <label class="field-label">Last Login:</label>
                <span class="field-value">{{ formatDate(userProfile.userLastLogin) }}</span>
              </div>

            </div>

            <div class="fields__block__section" *ngIf="!userProfile && !loading">
              <p>No profile information available.</p>
            </div>
          </div>

          <div class="fields__btn">
            <button class="gray" (click)="bsModalRef.hide()">Close</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
